import * as React from 'react';

import { ScammerAlert } from '../../components/ScammerAlert';
import { useRuntimeSetting } from '../../hooks/useRuntimeSetting';

export const ScammerAlertContainer = () => {
  const isScammerAlertShown = useRuntimeSetting<boolean>('frontend-chats.scammerAlert.Enabled', false);

  if (!isScammerAlertShown) {
    return null;
  }

  return <ScammerAlert />;
};
